export default __webpack_public_path__ + "static/media/header_img.dac54e0f.png";